/* Panier v3 (accord de Karim, 21/10) : « Retirer » avec annulation (6 s) et paiement collé en bas sur mobile.
 * Le thème recharge la section du panier après chaque changement : tout passe par délégation et par un observateur. */
(() => {
  if (window.PtxPanierV3) return;
  // Textes traduits (dictionnaire printtex-site-traductions, vide en français) ; {x} = valeur insérée.
  const ptxT = window.ptxT || (window.ptxT = (s) => (window.PTX_T && window.PTX_T[s]) || s);
  const ptxF = window.ptxF || (window.ptxF = (s, v) => ptxT(s).replace(/\{(\w+)\}/g, (m, k) => (v && k in v ? v[k] : m)));
  window.PtxPanierV3 = true;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // ---------- « Retirer » avec annulation ----------
  let toast = null, minuterie = 0, aRemettre = null;
  const afficher = (texte) => {
    if (!toast) {
      toast = document.createElement('div'); toast.className = 'ptx-annuler'; toast.setAttribute('role', 'status');
      toast.innerHTML = `<span data-t></span><button type="button" data-annuler>${ptxT('Annuler')}</button>`;
      document.body.appendChild(toast);
      toast.querySelector('[data-annuler]').addEventListener('click', remettre);
    }
    toast.querySelector('[data-t]').textContent = texte;
    requestAnimationFrame(() => toast.classList.add('is-on'));
    clearTimeout(minuterie); minuterie = setTimeout(() => { toast.classList.remove('is-on'); aRemettre = null; }, 6000);
  };
  async function remettre() {
    if (!aRemettre) return;
    const l = aRemettre; aRemettre = null;
    const b = toast.querySelector('[data-annuler]'); b.disabled = true; b.textContent = '…';
    try {
      // Même variante, même quantité, mêmes propriétés (fichiers d'impression, tailles, aperçu) : la ligne revient à l'identique.
      const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: l.id, quantity: l.q, properties: l.p || {} }] }) });
      if (!r.ok) throw new Error(String(r.status));
      location.reload();
    } catch (e) {
      toast.querySelector('[data-t]').textContent = 'Impossible de remettre l’article. Ajoutez-le à nouveau depuis sa fiche.';
      b.hidden = true;
    }
  }
  document.addEventListener('click', (e) => {
    const lien = e.target.closest('.cart__items a[is="cart-remove-button"], .cart__items cart-remove-button, .cart__items [is="cart-remove-button"]');
    if (!lien) return;
    const tr = lien.closest('[data-ptx-ligne]'); if (!tr) return;
    try {
      // Shopify garde les propriétés encodées en HTML : on les décode avant de les renvoyer.
      const brut = JSON.parse(tr.dataset.ptxLigne);
      const dec = (s) => { const t = document.createElement('textarea'); t.innerHTML = String(s); return t.value; };
      const p = {}; Object.entries(brut.p || {}).forEach(([k, v]) => { p[dec(k)] = dec(v); });
      aRemettre = { id: brut.id, q: brut.q, p };
      const nom = (tr.querySelector('.cart__item-title') || {}).textContent || ptxT('Article');
      afficher(ptxF('{nom} retiré.', { nom: nom.trim() }));
    } catch (err) { aRemettre = null; }
  }, true);

  // ---------- Paiement collé en bas (mobile) ----------
  let obs = null;
  const brancher = () => {
    const barre = document.querySelector('[data-ptx-payer]');
    const vrai = document.querySelector('.cart__sidebar button[name="checkout"]');
    if (!barre || !vrai || barre.dataset.ok) return;
    barre.dataset.ok = '1'; barre.hidden = false;
    // Au-dessus du menu du bas du site s'il est affiché.
    const dock = document.querySelector('.mobile-dock'); const h = dock && getComputedStyle(dock).visibility !== 'hidden' ? dock.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--ptx-payer-bas', Math.round(h) + 'px');
    if (obs) obs.disconnect();
    obs = new IntersectionObserver(([e]) => barre.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top > 0), { threshold: 0 });
    obs.observe(vrai);
  };
  const totalMaj = () => { const t = document.querySelector('.totals__subtotal-value'), c = document.querySelector('[data-ptx-payer-total]'); if (t && c) c.textContent = t.textContent.trim(); };
  const tout = () => { brancher(); totalMaj(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout); else tout();
  let attente = 0; new MutationObserver(() => { if (!attente) attente = requestAnimationFrame(() => { attente = 0; tout(); }); }).observe(document.body, { childList: true, subtree: true });
})();
